import React from 'react';
import { Shield, Lock, Eye, Database, Cookie, Mail } from 'lucide-react';
import './LegalPage.css';

export default function DatenschutzPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>🔒 Datenschutzerklärung</h1>
        <p className="legal-intro">
          Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von 
          personenbezogenen Daten (nachfolgend kurz „Daten") im Rahmen der Erbringung unserer Leistungen 
          sowie innerhalb unseres Onlineangebotes auf (nachfolgend „Website").
        </p>
        <p className="legal-intro">
          <strong>Gültig gemäß DSGVO (EU), DSG (Schweiz) und GDPR (UK)</strong>
        </p>

        <section>
          <h2><Shield size={24} className="section-icon" /> 1. Verantwortliche Stelle</h2>
          <div className="info-box">
            <p>
              <strong>Verantwortlich für die Datenverarbeitung:</strong><br />
              PedalScot<br />
              [Ihr Firmenname / Name]<br />
              [Straße und Hausnummer]<br />
              [PLZ und Ort], [Land]
            </p>
            <p>
              <strong>Kontakt Datenschutz:</strong><br />
              E-Mail: <a href="mailto:datenschutz@pedalscot.com">datenschutz@pedalscot.com</a><br />
              Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden.
            </p>
          </div>
        </section>

        <section>
          <h2><Database size={24} className="section-icon" /> 2. Erfasste Daten und Zwecke</h2>
          
          <h3>2.1 Registrierung und Benutzerkonto</h3>
          <p><strong>Erfasste Daten:</strong></p>
          <ul>
            <li>Name</li>
            <li>E-Mail-Adresse</li>
            <li>Passwort (verschlüsselt gespeichert)</li>
            <li>Profilbild (optional)</li>
            <li>Bike-Typ und Präferenzen</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
          <p><strong>Speicherdauer:</strong> Bis zur Löschung des Kontos</p>

          <h3>2.2 Routen und Aktivitäten</h3>
          <p><strong>Erfasste Daten:</strong></p>
          <ul>
            <li>Erstellte Routen und Touren</li>
            <li>Favoriten und Bookmarks</li>
            <li>Bewertungen und Reviews</li>
            <li>Feedback und Feature-Requests</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>

          <h3>2.3 Automatisch erfasste Daten (Server-Logs)</h3>
          <p><strong>Erfasste Daten:</strong></p>
          <ul>
            <li>IP-Adresse (anonymisiert nach 7 Tagen)</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Browser-Typ und Version</li>
            <li>Betriebssystem</li>
            <li>Referrer URL</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an IT-Sicherheit)</p>
          <p><strong>Speicherdauer:</strong> 7 Tage</p>
        </section>

        <section>
          <h2><Cookie size={24} className="section-icon" /> 3. Cookies und Tracking</h2>
          
          <h3>3.1 Technisch notwendige Cookies</h3>
          <p>
            Wir verwenden Cookies, um die Funktionalität unserer Website zu gewährleisten:
          </p>
          <ul>
            <li><strong>Session-Cookie:</strong> Aufrechterhaltung der Anmeldung</li>
            <li><strong>Preference-Cookie:</strong> Spracheinstellungen</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO</p>

          <h3>3.2 Analytics (PostHog)</h3>
          <p>
            Wir nutzen PostHog für anonymisierte Nutzungsstatistiken. Dabei werden folgende Daten erfasst:
          </p>
          <ul>
            <li>Anonymisierte Seitenaufrufe</li>
            <li>Klick-Ereignisse</li>
            <li>Geräteinformationen</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO / Ihre Einwilligung</p>
          <p><strong>Opt-Out:</strong> Sie können die Datenerfassung in den <a href="/cookies">Cookie-Einstellungen</a> deaktivieren.</p>
        </section>

        <section>
          <h2><Lock size={24} className="section-icon" /> 4. Datensicherheit</h2>
          <p>
            Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten 
            vor Manipulation, Verlust, Zerstörung oder dem Zugriff unberechtigter Personen zu schützen:
          </p>
          <ul>
            <li>SSL/TLS-Verschlüsselung für alle Datenübertragungen</li>
            <li>Passwörter werden mit bcrypt gehashed</li>
            <li>Zugriffsbeschränkungen und Authentifizierung</li>
            <li>Regelmäßige Sicherheitsupdates</li>
            <li>Datensicherungen (Backups)</li>
          </ul>
        </section>

        <section>
          <h2><Mail size={24} className="section-icon" /> 5. Weitergabe von Daten</h2>
          <p>
            Wir geben Ihre personenbezogenen Daten nur weiter, wenn:
          </p>
          <ul>
            <li>Sie ausdrücklich eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
            <li>Eine gesetzliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
            <li>Dies zur Vertragserfüllung erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</li>
          </ul>
          
          <h3>5.1 Eingesetzte Dienstleister</h3>
          <p><strong>Hosting & Infrastruktur:</strong> [Ihr Hosting-Provider]</p>
          <p><strong>Analytics:</strong> PostHog (EU-Server, DSGVO-konform)</p>
          <p><strong>E-Mail-Versand:</strong> SendGrid (optional, nur bei Aktivierung)</p>
          
          <p className="info-box">
            ℹ️ Alle Dienstleister sind vertraglich zur Einhaltung der Datenschutzbestimmungen verpflichtet.
          </p>
        </section>

        <section>
          <h2><Eye size={24} className="section-icon" /> 6. Ihre Rechte (DSGVO)</h2>
          <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
          <ul>
            <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO): Welche Daten werden gespeichert?</li>
            <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO): Korrektur falscher Daten</li>
            <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO): "Recht auf Vergessenwerden"</li>
            <li><strong>Recht auf Einschränkung</strong> (Art. 18 DSGVO): Einschränkung der Verarbeitung</li>
            <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO): Export Ihrer Daten</li>
            <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Widerspruch gegen Verarbeitung</li>
            <li><strong>Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO)</li>
          </ul>
          
          <div className="info-box">
            <p>
              <strong>Kontakt für Anfragen:</strong><br />
              E-Mail: <a href="mailto:datenschutz@pedalscot.com">datenschutz@pedalscot.com</a><br />
              Wir antworten innerhalb von 30 Tagen.
            </p>
          </div>
        </section>

        <section>
          <h2>7. Beschwerde bei Aufsichtsbehörde</h2>
          <p>
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren:
          </p>
          <ul>
            <li><strong>Deutschland:</strong> Ihr zuständiger Landesdatenschutzbeauftragter</li>
            <li><strong>Schweiz:</strong> Eidgenössischer Datenschutz- und Öffentlichkeitsbeauftragter (EDÖB)</li>
            <li><strong>Österreich:</strong> Datenschutzbehörde</li>
          </ul>
        </section>

        <section>
          <h2>8. Datenübertragung außerhalb der EU/EWR</h2>
          <p>
            Grundsätzlich verarbeiten wir Ihre Daten innerhalb der EU/EWR. Sollte eine Datenübertragung 
            in Drittländer erforderlich sein, erfolgt dies nur:
          </p>
          <ul>
            <li>Mit Ihrer ausdrücklichen Einwilligung</li>
            <li>Bei Vorliegen eines Angemessenheitsbeschlusses der EU-Kommission</li>
            <li>Unter Einsatz von EU-Standardvertragsklauseln</li>
          </ul>
        </section>

        <section>
          <h2>9. Speicherdauer</h2>
          <p>
            Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist:
          </p>
          <ul>
            <li><strong>Benutzerkonto:</strong> Bis zur Löschung durch Sie</li>
            <li><strong>Server-Logs:</strong> 7 Tage</li>
            <li><strong>Analytics:</strong> 90 Tage (anonymisiert)</li>
            <li><strong>Feedback:</strong> 2 Jahre</li>
          </ul>
        </section>

        <section>
          <h2>10. Änderungen der Datenschutzerklärung</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte 
            Rechtssituationen oder bei Änderungen des Dienstes anzupassen. Für erneute Besuche gilt 
            dann die neue Datenschutzerklärung.
          </p>
        </section>

        <section className="legal-meta">
          <p>
            <strong>Zuletzt aktualisiert:</strong> Januar 2025<br />
            <strong>Version:</strong> 1.0
          </p>
        </section>
      </div>
    </div>
  );
}
